export const USER_ID = 'user-id';

/** Menu sections. */
export const SECTION_NAME = {
  PERSONAL: 'Personal',
  ASSETS: 'Assets',
  BUSINESS: 'Business',
  EXPENSES: 'Expenses',
  QUALIFY: 'Qualify',
  FILE: 'File',
};
